<template>
    <Form ref="form" @submit="onSubmit">
        <div class="modal-header">
            <h4 v-if="matrixExist == 0" class="modal-title">
                {{ $getLocaleMessage('formTitles', 'create') }} una Matriz
            </h4>
            <h4 v-else class="modal-title">
                {{ $getLocaleMessage('formTitles', 'create') }} una Sucursal
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="card-body">
                <div class="form-group">
                    <label v-if="matrixExist == 0" for="name">Nombre de Matriz:</label>
                    <label v-else for="name">Nombre de Sucursal:</label>
                    <Field v-model="branchOffice.name" type="text" class="form-control" name="name" placeholder="Nombre"
                        rules="required|max:50" />
                    <ErrorMessage name="name" class="input-error"></ErrorMessage>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label for="address">Domicilio:</label>
                        <Field v-model="branchOffice.address" type="text" class="form-control" name="address"
                            placeholder="Domicilio" rules="max:80" />
                        <ErrorMessage name="address" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <label for="stateId">Estado:</label>
                    <StatesSelect v-model="branchOffice.stateId" :name="'stateId'" :options="localizationOptions"></StatesSelect>                
                </div>
                <div class="form-group">
                    <label for="rfc">RFC:</label>
                    <Field v-model="branchOffice.rfc" type="text" class="form-control" name="rfc" placeholder="RFC" rules="max:30" />
                    <ErrorMessage name="rfc" class="input-error"></ErrorMessage>
                </div>
                <div class="form-group">
                    <label for="phone">Teléfono Contacto:</label>
                    <Field v-model="branchOffice.phone" type="text" class="form-control" name="phone" placeholder="Teléfono" rules="max:50" />
                    <ErrorMessage name="phone" class="input-error"></ErrorMessage>
                </div>
                <div class="form-group">
                    <label for="email">Correo Contacto:</label>
                    <Field v-model="branchOffice.email" type="text" class="form-control" name="email" placeholder="Correo" rules="max:50" />
                    <ErrorMessage name="email" class="input-error"></ErrorMessage>
                </div>
                <div class="form-group">
                    <label for="legalName">Razón Social:</label>
                    <Field v-model="branchOffice.legalName" type="text" class="form-control" name="legalName" placeholder="Razón Social" rules="max:200" />
                    <ErrorMessage name="legalName" class="input-error"></ErrorMessage>
                </div>
                <div class="form-group">
                    <label for="idUser">Responsable:</label>
                    <UsersSelect v-model="branchOffice.userRel.id" :name="'idUser'" :options="userOptions"></UsersSelect>                
                </div>
                <div class="form-group">
                    <label for="statusId">Estatus:</label>
                    <StatusSelect v-model="branchOffice.statusId" :name="'statusId'" :options="statusOptions"></StatusSelect>                
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $getLocaleMessage('buttons', 'cancel') }}</button>
            <PrimaryButton class="btn btn-primary" type="submit">
                {{ $getLocaleMessage('buttons', 'create') }}
            </PrimaryButton>
        </div>
    </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from 'pinia';
import { useBranchOfficesStore } from '@/pinia/branchOffices.module';
import { useLocalizationStore } from '@/pinia/localization.module';
import { useUsersStore } from '@/pinia/users.module';
import { useStatusStore } from '@/pinia/status.module';

import PrimaryButton from '@/Components/PrimaryButton.vue';
import StatesSelect from '@/Components/Selects/SelectField.vue';
import UsersSelect from '@/Components/Selects/SelectField.vue';
import StatusSelect from '@/Components/Selects/SelectField.vue';

import BranchOffice from '@/Models/BranchOffice';

export default {
    components: { PrimaryButton, UsersSelect, StatusSelect, StatesSelect },
    mixins: [],
    data: () => ({
        branchOffice: new BranchOffice({
            municipalityId: 1, // Always set the default municipality to 1
            userRel: {id: 0}, // Initialize to avoid undefined error
        }),
        newStatusId: null,
        newStateId: null,
        selectedUser: null,
        countryId: 129,
    }),
    watch: {},
    computed: {
        ...mapState(useBranchOfficesStore, ['matrixExist']),
        ...mapState(useLocalizationStore, ['getStatesByCountry']),
        ...mapState(useUsersStore, ['getActiveUsers']),
        ...mapState(useStatusStore, ['getAllStatusByType', 'getSelectedStatus']),
        localizationOptions() {
            return helper.mapOptions(this.getStatesByCountry(this.countryId));
        },
        userOptions() {
            return helper.mapOptions(this.getActiveUsers, 'id', ['name', 'lastName']);
        },
        statusOptions() {
            return helper.mapOptions(this.getAllStatusByType(1));
        },
    },
    methods: {
        ...mapActions(useBranchOfficesStore, ['createBranchOffice', 'fetchBranchOffices']),
        ...mapActions(useStatusStore, ['setSelectedStatus']),
        onSubmit() {
            this.createBranchOffice(this.branchOffice);
            this.$refs.form.resetForm();
            this.closeModal();
        },
        closeModal() {
            this.$emit('closeModal', true);
        },
    },
    created() {},
    mounted() {}
};
</script>